import './App.css';
import Benchmarking from '../Benchmarking/Benchmarking';
import MobileNotification from '../MobileNotification/MobileNotification';

function App() {
  return (
    <div className="page">
      {window.innerWidth < 1279 && <MobileNotification />}
      <Benchmarking />
    </div>
  );
}

export default App;
